// removed by extract-text-webpack-plugin
module.exports = {"Loader":"Spinner__Loader__3-Jsa","load2":"Spinner__load2__P3vdn"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/UI/Spinner/Spinner.css
// module id = 166
// module chunks = 0